import type { ConversationType, ItemRow } from 'owa-graph-schema';

/**
 * Gets the priority view lookback cutoff date.
 * On Mondays, looks back to Friday; otherwise looks back to yesterday.
 */
function getPriorityViewCutoff(): Date {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const isMonday = now.getDay() === 1;
    const lookbackDays = isMonday ? 3 : 1;
    const cutoff = new Date(startOfToday);
    cutoff.setDate(cutoff.getDate() - lookbackDays);
    return cutoff;
}

/**
 * Filters item rows to only include items within the priority lookback window.
 * Uses ReceivedOrRenewTime so that snoozed (re-delivered) items are included.
 * On Mondays, includes Friday through Monday; otherwise includes today and yesterday.
 * @param rows - Array of ItemRow to filter
 * @returns Filtered array containing only recent items
 */
export function filterItemRowsForPriorityView(rows: ItemRow[]): ItemRow[] {
    const cutoff = getPriorityViewCutoff();

    return rows.filter(row => {
        if (!row.ReceivedOrRenewTime) {
            return false;
        }

        const receivedOrRenewDate = new Date(row.ReceivedOrRenewTime);
        return receivedOrRenewDate >= cutoff;
    });
}

/**
 * Filters conversation rows to only include conversations within the priority lookback window.
 * Uses LastDeliveryOrRenewTime so that snoozed (re-delivered) conversations are included.
 * On Mondays, includes Friday through Monday; otherwise includes today and yesterday.
 * @param rows - Array of ConversationType to filter
 * @returns Filtered array containing only recent conversations
 */
export function filterConversationRowsForPriorityView(
    rows: ConversationType[]
): ConversationType[] {
    const cutoff = getPriorityViewCutoff();

    return rows.filter(row => {
        if (!row.LastDeliveryOrRenewTime) {
            return false;
        }

        const lastDeliveryOrRenewDate = new Date(row.LastDeliveryOrRenewTime);
        return lastDeliveryOrRenewDate >= cutoff;
    });
}
